import React, { useState } from "react";
import { useFormik } from "formik";
import styled from "styled-components";
import contactPhoto from "../assets/BC-contact-photo.png";

const ContactUs = () => {
  const [hasSubmitted, setHasSubmitted] = useState(false);  
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      company: "",
      phone: "",
      message: "",
    },
    onSubmit: (values) => {

      //sumit form data to backend or do something with it
      // Example: submit form data to a REST API endpoint
      fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });
      setHasSubmitted(true);
    },
    
  });
  console.log(hasSubmitted)
  return (
    <Wrapper className="contact-us">
      <div className="content">
        <div className="col1">
          <div className="title">
            <h4>CONTACT US</h4>
          </div>
          <h2 className="subtitle">Get in touch with us!</h2>
          {!hasSubmitted === true ? (
            <div className="form-container"> 
            <h6>
              We would love to hear from you! Whether you have questions about our services, want to collaborate, or just want to say hello, feel free to reach out to us using the form below. We will get back to you as soon as possible.
            </h6>
            <form onSubmit={formik.handleSubmit} className="contact-form">
            <div className="row">
              <div className="field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  placeholder="someone"
                  required
                  {...formik.getFieldProps("name")}
                />
              </div>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="someone@mail.com"
                  required
                  {...formik.getFieldProps("email")}
                />
              </div>
            </div>
            <div className="row">
              <div className="field">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  id="company"
                  placeholder="Company"
                  {...formik.getFieldProps("company")}
                />
              </div>

              <div className="field">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                id="phone"
                placeholder="012345679"
                {...formik.getFieldProps("phone")}
              />
            </div>
            </div>
            <div className="row">
              <div className="field">
                <label htmlFor="message">Your Message</label>
                <textarea
                  id="message"
                  placeholder="Your Message"
                  required
                  rows="7"

                  {...formik.getFieldProps("message")}
                ></textarea>
              </div>
            </div>
            <div className="row">
              <button className="btn" type="submit">
                Send Message
              </button>
            </div>
          </form>
          </div>
          ) : (
            <h6>
              Thank you for reaching out to us! We have received your message and will get back to you as soon as possible.
            </h6>
          )}

          
        </div>
        <div className="col2">
          <img
            src={contactPhoto}
            alt="contactPhoto"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.section`
  padding-bottom: 2rem;
  padding: 1rem;
  display: block;
  background-color: #000;

  h2 {
    text-align: left;
    max-width: 1500px;
    display: block;
    color: var(--clr-white);
    margin-bottom: 1rem;
  }

  h3 {
    text-align: left;
    display: inline-block;
    color: var(--clr-white);

    margin-top: 0.5rem;
  }
  h6 {
    text-align: left;
    display: inline-block;
    color: var(--clr-white);
    margin: 0;
    margin-bottom: 1rem;
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 1rem;

    padding: 0rem;

    color: #6b6b6b;
    line-height: 1.6;
  }
  .col1,
  .col2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
    width: 100%;
    background-color: #000;
    margin-bottom: 1rem;
  }
  .col1 {
    justify-content: flex-start;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .form-container {
     width: 100%;
  }
  .title {
    text-align: center;
    border-radius: 5px;
    display: inline-block;
    border: 0.5px solid var(--clr-white);
    padding: 4px;
    color: var(--clr-white);
  }
  .subtitle {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
  .contact-form {
    width: 100%;
    padding-right: 2rem;
    display: flex;
    flex-direction: column;
  }
  .row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  .row > * {
    flex: 1; /* makes them equal width */
  }
  .field {
    display: flex;
    flex-direction: column;
  }
  label {
    margin-bottom: 0.5rem;
    color: var(--clr-white);
  }
  input,
  textarea {
    padding: 0.5rem;
    border-radius: 5px;
    border: none;
    background-color: #333;
    color: var(--clr-white);
  }
  .btn {
    background-color: var(--clr-primary-1);
    color: var(--clr-white);
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;
  }
  .btn:hover {
    background-color: var(--clr-primary-2);
  }

  @media (max-width: 768px) {
    .content {
      flex-direction: column;
      align-items: center;
    }
    .col1,
    .col2 {
      width: 100%;
      padding: 0;
    }
    .col1 {
      padding: 0 1rem;
    }
    .row {
      flex-direction: column;
    }
  }
`;
export default ContactUs;
